import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { HttpUtils } from '../../../../common/http/http-utils';

@Injectable()
export class DcService {
    private vcList: any;
    private dcList: any;
    private value: any;
    private depContUrlAdmin = '/admin/hybridity/api/global/deploymentContainers';
    private depContUrl = '/hybridity/api/compute/';

    constructor(public http: HttpClient) {
    }

    getVcList() {
        return this.http
            .get(HttpUtils.getBaseUrl() + '/hybridity/api/vc/query?entityType=vcenter')
            .map(res => this.vcList = res);
    }
    getDeploymentContainersForEdit() {
        return this.http
        .get(HttpUtils.getBaseUrl() + this.depContUrlAdmin)
        .map(res => this.dcList = res);
    }

    getDeploymentContainersForReadOnly(scopeId: string) {
        // hybridity/api/compute/{scopeId}/deploymentContainers
        return this.http
        .get(HttpUtils.getBaseUrl() + this.depContUrl + scopeId + '/deploymentContainers')
        .map(res => this.dcList = res);
    }

    addDeploymentContainer(payload) {
        let url = HttpUtils.getBaseUrl() + this.depContUrlAdmin;
        let body = {
            data: payload
        };
        return this.http
            .post(url, payload);
    };

    updateDeploymentContainer(payload, id) {
        let url = HttpUtils.getBaseUrl() + '/admin/hybridity/api/global/deploymentContainer/' +  id;
        let body = {
            data: payload
        };
        return this.http
            .put(url, payload);
    };

    deleteDeploymentContainer(id) {
        let url = HttpUtils.getBaseUrl() + '/admin/hybridity/api/global/deploymentContainer/' + id;
        return this.http
        .delete(url);
      }

}




// WEBPACK FOOTER //
// ./src/app/components/administration-main/deployment-container/dc.service.ts